import { observable } from 'mobx';

export type TravelerInformationResponseArgs = {
  id: number;
  name: string;
  user_name?: string;
  last_name_kana?: string;
  first_name_kana?: string;
  last_name_roman?: string;
  first_name_roman?: string;
  shinkansen_seat_type_text?: string;
  shinkansen_ticket_type_text?: string;
  show_railway_seat?: boolean;
};

export type TravelerInformationArgs = {
  id: number;
  name: string;
  userName?: string;
  lastNameKana?: string;
  firstNameKana?: string;
  lastNameRoman?: string;
  firstNameRoman?: string;
  shinkansenSeatTypeText?: string;
  shinkansenTicketTypeText?: string;
  showRailwaySeat?: boolean;
};

export const convertTravelerInformationResponseToArgs = (response: TravelerInformationResponseArgs) => {
  const args: TravelerInformationArgs = {
    id: response.id,
    name: response.name,
    userName: response.user_name,
    lastNameKana: response.last_name_kana,
    firstNameKana: response.first_name_kana,
    lastNameRoman: response.last_name_roman,
    firstNameRoman: response.first_name_roman,
    shinkansenSeatTypeText: response.shinkansen_seat_type_text,
    shinkansenTicketTypeText: response.shinkansen_ticket_type_text,
    showRailwaySeat: response.show_railway_seat
  };
  return args;
};

export default class TravelerInformation {
  @observable
  id: number;

  @observable
  name: string;

  @observable
  userName?: string;

  @observable
  lastNameKana?: string;

  @observable
  firstNameKana?: string;

  @observable
  lastNameRoman?: string;

  @observable
  firstNameRoman?: string;

  @observable
  shinkansenSeatTypeText?: string;

  @observable
  shinkansenTicketTypeText?: string;

  @observable
  showRailwaySeat?: boolean;

  constructor(args: TravelerInformationArgs) {
    this.id = args.id;
    this.name = args.name;
    this.userName = args.userName;
    this.lastNameKana = args.lastNameKana;
    this.firstNameKana = args.firstNameKana;
    this.lastNameRoman = args.lastNameRoman;
    this.firstNameRoman = args.firstNameRoman;
    this.shinkansenSeatTypeText = args.shinkansenSeatTypeText;
    this.shinkansenTicketTypeText = args.shinkansenTicketTypeText;
    this.showRailwaySeat = args.showRailwaySeat;
  }

  get travelerName() {
    if (this.userName) {
      return this.userName;
    }

    if (this.lastNameKana && this.firstNameKana) {
      return `${this.lastNameKana} ${this.firstNameKana}`;
    }

    if (this.lastNameRoman && this.firstNameRoman) {
      return `${this.lastNameRoman} ${this.firstNameRoman}`;
    }

    return '';
  }
}
